import _classCallCheck from "C:/saas/embarkable-marketing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/saas/embarkable-marketing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "C:/saas/embarkable-marketing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/saas/embarkable-marketing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/saas/embarkable-marketing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { TransitionMotion, spring } from "react-motion";
import cxs from "cxs";
import { isEqual } from "./isEqual";
import { requestTimeout, clearRequestTimeout } from "./utils";

var TextLoop = /*#__PURE__*/function (_React$Component) {
  _inherits(TextLoop, _React$Component);

  var _super = _createSuper(TextLoop);

  function TextLoop(props) {
    var _this;

    _classCallCheck(this, TextLoop);

    _this = _super.call(this, props);
    _this.isUnMounting = false;
    _this.tickDelay = 0;
    _this.tickLoop = 0;
    _this.wordBox = null;

    _this.willLeave = function () {
      var _this$getDimensions = _this.getDimensions(),
          height = _this$getDimensions.height;

      return {
        opacity: spring(_this.getOpacity(), _this.props.springConfig),
        translate: spring(-height, _this.props.springConfig)
      };
    };

    _this.willEnter = function () {
      var _this$getDimensions2 = _this.getDimensions(),
          height = _this$getDimensions2.height;

      return {
        opacity: _this.getOpacity(),
        translate: height
      };
    };

    _this.tick = function () {
      if (!_this.isUnMounting) {
        _this.setState(function (state, props) {
          var currentWordIndex = (state.currentWordIndex + 1) % state.elements.length;
          var currentEl = state.elements[currentWordIndex];
          var updatedState = {
            currentWordIndex: currentWordIndex,
            currentEl: currentEl,
            wordCount: (state.wordCount + 1) % 1000,
            currentInterval: Array.isArray(props.interval) ? props.interval[currentWordIndex % props.interval.length] : props.interval
          };

          if (props.onChange) {
            props.onChange(updatedState);
          }

          return updatedState;
        }, function () {
          if (_this.state.currentInterval > 0) {
            _this.clearTimeouts();

            _this.tickLoop = requestTimeout(_this.tick, _this.state.currentInterval);
          }
        });
      }
    };

    _this.wrapperStyles = cxs(Object.assign(Object.assign({}, _this.props.mask && {
      overflow: "hidden"
    }), {
      display: "inline-block",
      position: "relative",
      verticalAlign: "top"
    }));
    _this.elementStyles = cxs({
      display: "inline-block",
      left: 0,
      top: 0,
      whiteSpace: _this.props.noWrap ? "nowrap" : "normal"
    });
    var elements = React.Children.toArray(props.children);
    _this.state = {
      elements: elements,
      currentEl: elements[0],
      currentWordIndex: 0,
      wordCount: 0,
      currentInterval: Array.isArray(props.interval) ? props.interval[0] : props.interval
    };
    return _this;
  }

  _createClass(TextLoop, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var delay = this.props.delay;
      var _this$state = this.state,
          currentInterval = _this$state.currentInterval,
          elements = _this$state.elements;

      if (currentInterval > 0 && elements.length > 1) {
        this.tickDelay = requestTimeout(function () {
          _this2.tickLoop = requestTimeout(_this2.tick, currentInterval);
        }, delay);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this3 = this;

      var _this$props = this.props,
          interval = _this$props.interval,
          children = _this$props.children,
          delay = _this$props.delay;
      var currentWordIndex = this.state.currentWordIndex;
      var currentInterval = Array.isArray(interval) ? interval[currentWordIndex % interval.length] : interval;

      if (prevState.currentInterval !== currentInterval) {
        this.clearTimeouts();

        if (currentInterval > 0 && React.Children.count(children) > 1) {
          this.tickDelay = requestTimeout(function () {
            _this3.tickLoop = requestTimeout(_this3.tick, currentInterval);
          }, delay);
        } else {
          this.setState(function (state, props) {
            var _currentWordIndex = state.currentWordIndex;
            return {
              currentInterval: Array.isArray(props.interval) ? props.interval[_currentWordIndex % props.interval.length] : props.interval
            };
          });
        }
      }

      if (!isEqual(prevProps.children, children)) {
        this.setState({
          elements: React.Children.toArray(children)
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isUnMounting = true;
      this.clearTimeouts();
    }
  }, {
    key: "clearTimeouts",
    value: function clearTimeouts() {
      if (this.tickLoop != null) {
        clearRequestTimeout(this.tickLoop);
      }

      if (this.tickDelay != null) {
        clearRequestTimeout(this.tickDelay);
      }
    }
  }, {
    key: "getOpacity",
    value: function getOpacity() {
      return this.props.fade ? 0 : 1;
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      if (this.wordBox == null) {
        return {
          width: 0,
          height: 0
        };
      }

      return this.wordBox.getBoundingClientRect();
    }
  }, {
    key: "getTransitionMotionStyles",
    value: function getTransitionMotionStyles() {
      var springConfig = this.props.springConfig;
      var _this$state2 = this.state,
          wordCount = _this$state2.wordCount,
          currentEl = _this$state2.currentEl;
      return [{
        key: "step-".concat(wordCount),
        data: {
          currentEl: currentEl
        },
        style: {
          opacity: spring(1, springConfig),
          translate: spring(0, springConfig)
        }
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props$className = this.props.className,
          className = _this$props$className === void 0 ? "" : _this$props$className;
      return React.createElement("div", {
        className: "".concat(this.wrapperStyles, " ").concat(className)
      }, React.createElement(TransitionMotion, {
        willLeave: this.willLeave,
        willEnter: this.willEnter,
        styles: this.getTransitionMotionStyles()
      }, function (interpolatedStyles) {
        var _this4$getDimensions = _this4.getDimensions(),
            height = _this4$getDimensions.height,
            width = _this4$getDimensions.width;

        var parsedWidth = _this4.wordBox == null ? "auto" : width;
        var parsedHeight = _this4.wordBox == null ? "auto" : height;
        return React.createElement("div", {
          style: {
            transition: "width ".concat(_this4.props.adjustingSpeed, "ms linear"),
            height: parsedHeight,
            width: parsedWidth
          }
        }, interpolatedStyles.map(function (config) {
          return React.createElement("div", {
            className: _this4.elementStyles,
            ref: function ref(n) {
              _this4.wordBox = n;
            },
            key: config.key,
            style: {
              opacity: config.style.opacity,
              transform: "translateY(".concat(config.style.translate, "px)"),
              position: _this4.wordBox == null ? "relative" : "absolute"
            }
          }, config.data.currentEl);
        }));
      }));
    }
  }]);

  return TextLoop;
}(React.Component);

TextLoop.defaultProps = {
  interval: 3000,
  delay: 0,
  adjustingSpeed: 150,
  springConfig: {
    stiffness: 340,
    damping: 30
  },
  fade: true,
  mask: false,
  noWrap: true
};
export default TextLoop;